import {
  DIMENSION_NAME_PRODUCT,
  ProductDimension,
  DimensionsList
} from '../../../../constants/StaticFilterValues';

export interface GetDimensionsReportingRequest {
  dimensionName: string,
  hierarchyName: string,
  filterValue: string;
  level: number;
  startKey?: number;
}

export interface GetAllDimensionsReportingRequest {
    dimensionNames: DimensionsList[];
    hierarchyName?: string | null;
    startKey?: number | null;
    filterValue?: string | null;
    level?: number | null;
    avoidPagination?: boolean;
}

export interface GetAllDimensionsReportingResponse {
  dimensionValues?: any[];
  lastEvaluatedKey?: any;
}

export const generateAllDimensionsProductLineRequest = (params: GetDimensionsReportingRequest): GetAllDimensionsReportingRequest => {
    const isSearchRequest = params.level === undefined;

    const request: GetAllDimensionsReportingRequest = {
        dimensionNames: [
            { productDimension: ProductDimension.PRODUCT },
            { productDimension: ProductDimension.ALTPRODUCT }
        ],
        startKey: params.startKey || null,
        filterValue: params.filterValue || null,
        avoidPagination: false
    };

    if (isSearchRequest) {
        request.level = undefined;
    } else if (params.level !== undefined) {
        request.level = params.level + 1;
        request.hierarchyName = params.hierarchyName;
    }

    return request;
};
